import { IsNullOrEmptyHtml } from "helpers/stringHelper";
import AccordionLargeTextDisplay from "newui/components/AccordionLargeTextDisplay";
import InfoBox from "newui/components/InfoBox";

interface QuoteInstructionsProps {
	isLoading?: boolean;
	quoteInstructions?: string;
}

const QuoteInstructions: React.FC<QuoteInstructionsProps> = ({
	isLoading = false,
	quoteInstructions,
}) => {
	if (IsNullOrEmptyHtml(quoteInstructions)) {
		return null;
	}

	return (
		<InfoBox className="pb-2">
			<AccordionLargeTextDisplay
				isLoading={isLoading}
				maxTextDisplay={300}
				text={quoteInstructions}
				title="Quote Instructions/Further Information"
			/>
		</InfoBox>
	);
};

export default QuoteInstructions;
